import { Helper } from './../shared/helper';
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { ITicket } from './ticket';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import { environment } from '../../environments/environment';
import { CustomLogger } from '../shared/custom-logger';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class TicketService {
  private ticketUrl = environment.ticketUrl;
  private checkTicketUrl = environment.checkTicketUrl;
  private holdTicketUrl = environment.holdTicketUrl;
  private unHoldTicketUrl = environment.unHoldTicketUrl;

  constructor(
    private http: HttpClient,
    private logger: CustomLogger,
    private helper: Helper
  ) {}


  getUrlForTicketsExport(params: any, order: string, urlSuf: string): string {
    urlSuf = '?' + order;
    if (params.flightNumber) {
      urlSuf += `&ticketFlight[flightNumber]=${params.flightNumber}`;
    }
    if (params.ticketBranch) {
      urlSuf += `&ticketIssuer[branch][id]=${params.ticketBranch}`;
    }
    delete params.flightNumber;
    delete params.flightDateTime;
    delete params.ticketBranch;

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        urlSuf += '&' + key + '=' + params[key];
      }
    }

    return urlSuf;
  }

  getTickets(params: any, order = ''): Observable<HttpResponse<ITicket[]>> {
    let urlSuf = order;
    if (params.flightNumber) {
      urlSuf += `&ticketFlight.flightNumber=${params.flightNumber}`;
    }
    if (params.flightDateTime) {
      urlSuf += params.flightDateTime;
    }
    if (params.ticketCreated) {
      urlSuf += params.ticketCreated;
    }
    if (params.ticketBranch) {
      urlSuf += `&ticketIssuer.branch.id=${params.ticketBranch}`;
    }
    if (params.ticketIssuer) {
      urlSuf += `&ticketIssuer.id=${params.ticketIssuer}`;
    }
    if (params.flightId) {
      urlSuf += `&ticketFlight.id=${params.flightId}`;
    }

    delete params.flightNumber;
    delete params.flightDateTime;
    delete params.ticketBranch;
    delete params.ticketCreated;
    delete params.ticketUser;
    delete params.flightId;

    return this.http
      .get<ITicket[]>(this.ticketUrl + urlSuf, {
        params: params,
        observe: 'response'
      })
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  checkTicket(id: number) {
    const ticketData = { flight_id: id };
    return this.http
      .post(this.checkTicketUrl, ticketData)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  holdTicket(id?: number, adultAmount?: number, infantAmount?: number) {
    const ticketData = <any>{};
    if (adultAmount || infantAmount) {
      ticketData.flight_id = id;
      ticketData.tickets_amount = adultAmount;
      ticketData.infant_amount = infantAmount;
    } else {
      ticketData.hold_id = id;
    }
    return this.http
      .post(this.holdTicketUrl, ticketData)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  deleteTicketHold(id: number) {
    const ticketData = { hold_id: id };
    return this.http
      .post(this.unHoldTicketUrl, ticketData)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  getTicket(id: number): Observable<ITicket> {
    // if (id === 0) {
    //   return Observable.of(this.initializeTicket());
    // }
    const url = `${this.ticketUrl}/${id}`;
    return this.http
      .get<ITicket>(url)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  // initializeTicket(): ITicket {
  //   return {
  //     id: 0,
  //     flightNumber: null,
  //     departure: {
  //       id: null,
  //       name: null
  //     },
  //     destination: {
  //       id: null,
  //       name: null
  //     },
  //     price: null
  //   };
  // }

  saveTicket(ticket: ITicket): Observable<ITicket> {
    if (ticket.id === 0) {
      return this.createTicket(ticket);
    }
    return this.updateTicket(ticket);
  }

  createTicket(ticket: ITicket): Observable<ITicket> {
    return this.http
      .post<ITicket>(this.ticketUrl, ticket)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  updateTicket(ticket: any): Observable<ITicket> {
    const url = `${this.ticketUrl}/${ticket.id}`;
    return this.http
      .put<ITicket>(url, ticket)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }

  deleteTicket(id: number): Observable<any> {
    const url = `${this.ticketUrl}/${id}`;
    return this.http
      .delete(url)
      .do(data => this.logger.log(data))
      .catch(this.logger.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/tickets/ticket.service.ts